import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';

const Body = (props) => (
    <React.Fragment>
        {
            !props.brandSales || !props.brandSales.list || props.brandSales.list.length == 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {props.beginDate ?
                                <p><i>From</i> <b>{moment(props.beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {props.endDate ? <b>{moment(props.endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <br />
                    <div className="table-responsive">
                        {
                            props.brandSales && props.brandSales.list.map(item => {
                                return (

                                    <div className="row m-0 mb-2  text-center" key={item.brand} >
                                        <div className="row m-0 mb-2">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-md- text-center">
                                                <label>Brand</label>
                                                <h3 className="m-0 grey-text">{item.brand}</h3>
                                            </div> {/* Column Orders */}

                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-md- text-center">
                                                {/* <div className="table_icon"><ActionCardGiftcard/></div> */}
                                                <label>Total Sales</label>
                                                <h3 className="m-0 green-text"><strong>{getDollarFormat(item.total)}</strong></h3>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                </div>
        }
    </React.Fragment>
);

export default Body;